import Loadable from 'react/components/loadable';

const MigrateEventSeriesModal = Loadable({
  loader: () => import('../../pages/calendar/migrate_event_series_modal'),
  type: 'modal',
});

angular.module('gym').value('MigrateEventSeriesModal', MigrateEventSeriesModal);
